import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-arch-modules',
	templateUrl:'./ModuleGraphPage.html',
	styles: [],
	styleUrls:['./ModuleGraphPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class ModuleGraphPage
{
	mdContent_24 = `Every JWebMP module declares its dependencies explicitly in \`module-info.java\`. The JPMS module graph ensures clean boundaries — no classpath hell, no hidden dependencies, no runtime surprises.`;
	mdContent_25 = `\`\`\`mermaid
graph TD
  CORE["com.jwebmp.core"]
  CLIENT["com.jwebmp.client<br/>SPI contracts, AJAX pipeline"]
  GUICEE["com.guicedee.client<br/>DI, lifecycle, CallScope"]
  VERTX["com.guicedee.vertx<br/>Vert.x lifecycle, event bus"]
  VXC["io.vertx.core"]
  VXW["io.vertx.web"]
  GUICE["com.google.guice<br/>Dependency injection"]
  JACKSON["com.fasterxml.jackson<br/>JSON serialization"]
  JAKARTA["jakarta.validation<br/>Bean Validation"]
  COMMONS["org.apache.commons.*<br/>Utilities"]

  CORE --> CLIENT
  CORE --> GUICEE
  CORE --> VERTX
  CORE --> VXC
  CORE --> VXW
  CORE --> GUICE
  CORE --> JACKSON
  CORE --> JAKARTA
  CORE --> COMMONS

\`\`\``;
}
